import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAsignatures } from '../asginatures/Asignatures';
import { useGrades } from '../grades/Grades';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
}));

function useForm(e) {
  const [entries, setEntries] = useState([]);
  function handleChange(e) {
    let { name, value } = e.target;
    if (value.includes('{') && value.includes('}')) {
      value = JSON.parse(value);
    }

    const resourceTypeAssociations = {
      video: 'Single',
      imagen: 'Single',
      audio: 'Single',
      pdf: 'Single',
      imagenes: 'Multiple',
      pdfi: 'Multiple',
    };

    if (name === 'resourceType') {
      setEntries({ ...entries, resourceType: resourceTypeAssociations[value] });
    } else {
      setEntries({ ...entries, [name]: value });
    }
  }

  return {
    handleChange,
    entries,
  };
}

export function CreateResource(props) {
  const { asignatures } = useAsignatures();
  const { grades } = useGrades();
  const { entries, handleChange } = useForm();
  const fileInput = useRef(null);
  const classes = useStyles();
  const navigate = useNavigate();

  const handleCreateResource = async () => {
    const formData = new FormData();
    formData.append('title', entries?.title);
    formData.append('description', entries?.description);
    formData.append('grade', entries?.grade);
    formData.append('asignature', entries?.asignature);
    formData.append('resourceType', entries?.resourceType);
    formData.append('resource', fileInput?.current?.files[0]);
    const response = await fetch(
      'https://api.edicionesmilenio.com/api/resources',
      {
        method: 'POST',
        body: formData,
      }
    );
    const json = await response.json();
    navigate('/admin/resources');
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás crear un nuevo recurso
        para la plataforma, estos recursos corresponden a los creados por la
        editorial y están asociados a la asignatura y grado, los tipos de
        recursos autorizados para crear son: video, audio, PDF, imagen y
        mapa(img).
      </p>
      <div
        style={{
          width: '100%',
          paddingLeft: '20px',
          paddingRight: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-asignature-label">
            Seleccione una asignatura
          </InputLabel>
          <Select
            labelId="select-asignature-label"
            id="select-asignature"
            value={entries?.asignature}
            name="asignature"
            onChange={handleChange}
            label="Seleccione una asignatura"
          >
            <MenuItem value="" disabled>
              <em>Seleccione una asignatura</em>
            </MenuItem>
            {asignatures?.map((asignature, index) => (
              <MenuItem value={asignature?._id}>{asignature?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade-label">Seleccione un grado</InputLabel>
          <Select
            labelId="select-grade-label"
            id="select-grade"
            value={entries?.grade}
            name="grade"
            onChange={handleChange}
            label="Seleccione un grado"
          >
            <MenuItem value="" disabled>
              <em>Seleccione un grado</em>
            </MenuItem>
            {grades?.map((grade, index) => (
              <MenuItem value={grade?._id}>{grade?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          className={classes.input}
          label="Título"
          variant="outlined"
          name="title"
          value={entries?.title}
          onChange={handleChange}
        />
        <TextField
          className={classes.input}
          label="Descripción"
          variant="outlined"
          name="description"
          value={entries?.description}
          onChange={handleChange}
        />
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-type-label">Tipo de recurso</InputLabel>
          <Select
            labelId="select-type-label"
            id="select-type"
            value={entries?.resourceType}
            name="resourceType"
            onChange={handleChange}
            label="Tipo de recurso"
          >
            <MenuItem value="" disabled>
              <em>Seleccione un tipo</em>
            </MenuItem>
            <MenuItem value="video">Video</MenuItem>
            <MenuItem value="audio">Audio</MenuItem>
            <MenuItem value="pdf">Documento PDF</MenuItem>
            <MenuItem value="imagen">Imagen</MenuItem>
            {/* <MenuItem value="imagenes">Imagenes</MenuItem>
            <MenuItem value="pdfi">PDF Interactivo</MenuItem> */}
          </Select>
        </FormControl>
        <div
          onClick={() => {
            fileInput.current.click();
          }}
          style={{
            marginTop: '20px',
            border: '1px solid #ccc',
            paddingTop: '15px',
            paddingBottom: '15px',
            paddingLeft: '15px',
            borderRadius: '5px',
            cursor: 'pointer',
            color: '#777',
          }}
        >
          <input
            ref={fileInput}
            style={{ display: 'none' }}
            type="file"
            name="resource"
            onChange={handleChange}
            multiple={entries?.resourceType === 'Multiple'}
          />
          {entries?.resourceType === 'Multiple'
            ? 'Seleccione los archivos (zip, jpg)'
            : 'Seleccione el archivo (jpg, pdf, mp4, mp3)'}
        </div>
        <Button
          style={{ background: '#2490AF', marginTop: '20px' }}
          onClick={handleCreateResource}
          variant="contained"
          color="primary"
          disabled={
            entries?.asignature === undefined ||
            entries?.grade === undefined ||
            entries?.title === undefined ||
            entries?.description === undefined ||
            entries?.resourceType === undefined ||
            entries?.resource === undefined
          }
        >
          Crear recurso
        </Button>
      </div>
    </div>
  );
}
